import { useEffect, useState } from 'react';
import LogsDS from '../../DataServices/LogsDs';
import './logs.css';
import { useCustomContext } from '../CustomComponents/CustomComponents';

const PAGE_SIZE = 10;

const LogsMobileUI = () => {
  const logsDS = new LogsDS();
  const { showAlert, hud, stopHudRotation } = useCustomContext();

  const [logs, setLogs] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    if (loading || !hasMore) return;

    setLoading(true);
    hud("Please Wait...");

    try {
      const response = await logsDS.RM_Activity_Logs_GET({ limit: PAGE_SIZE, offset });
      const data = response.data;
      const body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;

      if (data.statusCode === 200 && Array.isArray(body.records)) {
        const newLogs = body.records;
        setLogs(prev => [...prev, ...newLogs]);
        setOffset(prev => prev + PAGE_SIZE);
        setHasMore(newLogs.length === PAGE_SIZE); // no more if less than page size
      } else {
        setHasMore(false);
        const errorMessage = body?.message || 'Unexpected data format.';
        showAlert(errorMessage, [
          { label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }
        ]);
      }
    } catch (error) {
      console.error('Error:', error);
      showAlert(
        error.response?.data?.message || error.message || 'An error occurred.',
        [{ label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }]
      );
    } finally {
      setLoading(false);
      stopHudRotation();
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const trimLongWords = (text, maxLen = 80) =>
    text
      .split(' ')
      .map(word => (word.length > maxLen ? word.slice(0, maxLen) + '...' : word))
      .join(' ');

  return (
    <div>
      <div className="user-mobile-header">
        <h5 className="user-mobile-header-text">Logs</h5>
      </div>

      <div className="logs-cards-container">
        {logs.length > 0 ? (
          <>
            {logs.map((log, index) => (
              <div className="log-card" key={index}>
                <div className="log-row">
                  <span className="log-value">
                    {trimLongWords(log.Description)} <br />
                    {new Date(log.AddedTimeStamp).toLocaleString()}
                  </span>
                </div>
              </div>
            ))}

            {/* Show Load More only if there are more logs to load */}
            {hasMore && (
              <button className="load-more-btn" onClick={() => fetchLogs(false)} disabled={loading}>
                {loading ? 'Loading...' : 'Load More logs'}
              </button>
            )}
          </>
        ) : (
          <p className="no-logs-msg">No logs available</p>
        )}
      </div>
    </div>

  );
};

export default LogsMobileUI;
